import CreditCardProvider from "./enums/CreditCardProvider.js";
import TariffKind from "./enums/TariffKind";
import {TariffId} from "./nominalTypes/TariffId";
import {ZoneId} from "./nominalTypes/ZoneId";
import {InstallationByHostData} from "./types/InstallationByHostData";
import {IntegraHolderData} from "./types/IntegraHolderData";
import {ParkingTariff} from "./types/ParkingTariff.js";
import {PaymentProvider} from "./types/PaymentProvider.js";

class Tariffs {
	static find(value: InstallationByHostData, tariffId: TariffId): ParkingTariff | undefined {
		for (const tariff of value.tariffs) {
			if (tariff.type === tariffId) return tariff;
		}
		return undefined;
	}

	static get(value: InstallationByHostData, tariffId: TariffId): ParkingTariff {
		let tariff = this.find(value, tariffId);
		if (tariff != null) {
			return tariff;
		}

		return {
			title: tariffId,
			description: ["—"],
			type: tariffId,
			zoneIds: [],
			cancellable: false,
			selectable: false,
			kind: TariffKind.Permits
		}
	}

	static getAll(value: InstallationByHostData, tariffIds: TariffId[]): ParkingTariff[] {
		const result: ParkingTariff[] = [];
		for (const t of tariffIds) {
			result.push(this.get(value, t));
		}
		return result;
	}

	static getByZone(value: InstallationByHostData, zoneId: ZoneId): ParkingTariff[] {
		const result: ParkingTariff[] = [];
		for (const x of value.tariffs) {
			if (x.zoneIds.includes(zoneId)) {
				result.push(x);
			}
		}
		return result;
	}

	static getZones(value: InstallationByHostData, tariffId: TariffId): ZoneId[] {
		for (const x of value.tariffs) {
			if (x.type === tariffId) {
				return x.zoneIds;
			}
		}
		return [];
	}

	static getPaymentProvider(value: IntegraHolderData, creditCardProvider: CreditCardProvider): PaymentProvider | undefined {
		let selected = creditCardProvider || value.paymentProviders?.creditCard?.provider;
		if (selected == null) return undefined;
		const providers = value.paymentProviders?.providers;
		if (providers == null) return undefined;
		for (const x of providers) {
			if (x.id === selected) return x;
		}
		return undefined;
	}
}

export {Tariffs};
